export const environment = {
  production: true,
  BaseApi: "https://api.zoom2i.com/API/",
  // BaseApi: "https://api-qr-test.zoom2i.com/API/",
  // BaseApi: "http://localhost:16532/api/",
  // BaseApi: " http://192.250.228.26:8081/API/",
  //
  // BaseApi: "http://localhost:5245/API/",
};
